module.exports = __webpack_public_path__ + "img/authForteKoOther.ee6028f2.png";